module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00014-fs8.dfe57da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00014-fs8.png
// module id = 167
// module chunks = 0